// extracted by mini-css-extract-plugin
export default {"criteriaTopHeaderColumn":"criteriaTopHeaderColumn-xh9pG","countOfLevels":"countOfLevels-rh7Uf","criteriaColumn":"criteriaColumn-q3caN"};